import {observer} from 'mobx-react'
import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import AppInput from '../../components/control/custom_input/app_input'
import ConfirmButton from '../../components/control/button/confirm_button'
import {AUTH_TIME, FORMAT, IMP_CPID, IMP_PG, IsDev} from '../../config/const'
import {checkEmail, checkPwd, getTimeFromSecond} from '../../helper/common'
import DateTime from 'react-datetime'

const Signup = observer((props) => {
  const info = props.location.state ? props.location.state.info : null
  const context = useContext(Page_settings)

  let [step, setStep] = useState(1)
  let [email, setEmail] = useState('')
  let [pwd, setPwd] = useState('')
  let [pwdD, setPwdD] = useState('')
  let [nickname, setNickname] = useState('')
  let [phone, setPhone] = useState('')
  let [name, setName] = useState('')
  let [birth, setBirth] = useState('')
  let [emailAlarm, setEmailAlarm] = useState(false)
  let [emailChecked, setEmailChecked] = useState(false)
  let [nickChecked, setNickChecked] = useState(false)
  let [authStatus, setAuthStatus] = useState(-1)
  let [emailError, setEmailError] = useState('')
  let [auth, setAuth] = useState('')
  let [nameError, setNameError] = useState('')
  let [phoneError, setPhoneError] = useState('')
  let [authError, setAuthError] = useState('')
  let [pwdError, setPwdError] = useState('')
  let [pwdDError, setPwdDError] = useState('')
  let [nicknameError, setNicknameError] = useState('')
  let [birthError, setBirthError] = useState('')
  let [authTime, setAuthTime] = useState(AUTH_TIME)
  let [countDown, setCountDown] = React.useState(0)
  let [enabled, setEnabled] = useState(false)
  let [type, setType] = useState(1)
  let [birthValid, setBirthValid] = useState(false)
  let moment = require('moment')
  let initialBirth = (info && info.birth) ? moment(info.birth).format(FORMAT.DATE) : ''
  let [agreement, setAgreement] = useState([])
  const agreementList = [
    {id: "usage"},
    {id: "privacy"},
  ];

  useEffect(() => {
    if (info) {
      let birth = info.birth ?? ''
      setType(info.type)
      setEmail(info.email ?? '')
      setBirth(birth)
      setPhone(info.tel ?? '')
      setName(info.name ?? '')
      setAuthStatus(2)
      birth = birth.replace(/-/g, '')
      setBirthValid(birth.length === 8)
    }
  }, [])

  useEffect(() => {
    setEmailError('')
    checkEnabled()
  }, [email])

  useEffect(() => {
    if (authTime === 0) {
      setAuthTime(AUTH_TIME)
      setAuthStatus(0)
      setAuth('')
      clearInterval(countDown)
    }
  }, [authTime])

  useEffect(() => {
    setAuthError('')
    checkEnabled()
  }, [auth])

  useEffect(() => {
    setPwdError('')
    checkEnabled()
  }, [pwd])

  useEffect(() => {
    setPwdDError('')
    checkEnabled()
  }, [pwdD])

  useEffect(() => {
    setNicknameError('')
    checkEnabled()
  }, [nickname])

  useEffect(() => {
    setNameError('')
    checkEnabled()
  }, [name])

  useEffect(() => {
    setPhoneError('')
    checkEnabled()
  }, [phone])

  useEffect(() => {
    setBirthError('')
    checkEnabled()
  }, [birth])

  useEffect(() => {
    checkEnabled()
  }, [authStatus, emailChecked, nickChecked, emailAlarm, nickname, pwd, pwdD, phone, name, birth, agreement])


  const toogleSingleAgreement = (id) => {
    if (!agreement.includes(id)) setAgreement(prev => [...prev, id]);
    else setAgreement(agreement.filter((el) => el !== id));
  };

  const toogleAllAgreement = () => {
    if(agreement.length !== agreementList.length) {
      const idArray = [];
      agreementList.forEach((el) => idArray.push(el.id));
      setAgreement(idArray);
    }
    else {
      setAgreement([]);
    }
  }

  const handleSubmit = e => {
    if (!enabled) return

    let checked = true
    if (!checkEmail(email)) {
      checked = false
      setEmailError(strings.invalid_email)
    }
    if (info == null) {
      if (pwd === '') {
        checked = false
        setPwdError(strings.pwd_hint)
      }
      if (checked && !checkPwd(pwd)) {
        checked = false
        setPwdError(strings.invalid_pwd)
      }
      if (pwdD === '') {
        checked = false
        setPwdDError(strings.pwd_hint)
      }
      if (pwdD !== '' && pwd !== pwdD) {
        checked = false
        setPwdDError(strings.pwd_mismatch)
      }
    }
    phone = phone.replace(/-/g, '').replace(/ /g, '')
    if (phone === '') {
      checked = false
      setPhoneError(strings.phone_hint)
    }
    if (phone !== '' && phone.length !== 11) {
      checked = false
      setPhoneError(strings.invalid_hint)
    }
    birth = moment(birth).format(FORMAT.DATE).replace(/-/g, '')
    if (birth === '') {
      checked = false
      setBirthError(strings.birthday_hint)
    }
    if (birth !== '' && birth.length !== 8) {
      checked = false
      setBirthError(strings.invalid_birthday)
    }
    if (!checked) return

    context.post('member/checkPhone', {type: type, phone: phone},
      () => {
        if (IsDev) {
          context.post('member/signup', {type: type, sns_id: info?.sns_id ?? '', email: email, pwd: pwd, nick: nickname, name: name, birth: birth, tel: phone, gender: info?.gender ?? 1},
            () => {
              setStep(2)
            },
            true,
            err => {
              context.showAlert(err.msg)
            }
          )
          return
        }
        doIMP()
      },
      false,
      err => {
        setPhoneError(err.msg)
      }
    )
  }

  const checkEnabled = () => {
    setEnabled(agreement.length === agreementList.length && (type > 1 || (type === 1 && emailChecked && pwd !== '' && pwd === pwdD)) && nickChecked && phone !== '' && name !== '' && birth !== '') //emailAlarm &&
  }

  const sendAuth = () => {
    if (email === '') {
      setEmailError(strings.email_hint)
      return
    }
    if (!checkEmail(email)) {
      setEmailError(strings.invalid_email)
      return
    }
    context.post('member/requestAuth', {type: 'email', key: email},
      () => {
        setEmailError('')
        setAuthStatus(1)
        setAuthTime(AUTH_TIME)
        clearInterval(countDown)
        setCountDown(setInterval(() => {
          setAuthTime(prevTime => prevTime - 1)
        }, 1000))
      },
      true,
      err => {
        setEmailError(err.msg)
      }
    )
  }

  const requestAuth = () => {
    if (auth === '') {
      setAuthError(strings.input_auth)
      return
    }
    context.post('member/confirmAuth', {type: 'signup', key: email, val: auth},
      () => {
        clearInterval(countDown)
        setAuthStatus(2)
      },
      true,
      err => {
        setAuthError(err.msg)
      }
    )
  }

  const checkID = () => {
    if (email === '') {
      setEmailError(strings.email_hint)
      return
    }
    if (!checkEmail(email)) {
      setEmailError(strings.invalid_email)
      return
    }
    context.post('member/checkEmail', {email: email},
      () => {
        context.showAlert(strings.valid_email)
        setEmailChecked(true)
      },
      true,
      err => {
        setEmailError(err.msg)
      }
    )
  }

  const checkNickname = () => {
    if (nickname === '') {
      setNicknameError(strings.nickname_hint)
      return
    }
    context.post('member/checkNickname', {nickname: nickname},
      () => {
        context.showAlert(strings.valid_nickname)
        setNickChecked(true)
      },
      true,
      err => {
        setNicknameError(err.msg)
      }
    )
  }

  const doIMP = () => {
    window.IMP.certification({
      pg: `${IMP_PG}.${IMP_CPID}`, //본인인증 설정이 2개이상 되어 있는 경우 필수
      merchant_uid: 'order' + new Date().getTime(),
      name: name,
      phone: phone,
      //m_redirect_url: '', // 모바일환경에서 popup:false(기본값) 인 경우 필수
      popup: true, // PC환경에서는 popup 파라미터가 무시되고 항상 true 로 적용됨
    }, function (rsp) {
      //console.log(rsp)
      if (!rsp.success) {
        context.showAlert('본인인증이 실패되었습니다. - ' +  rsp.error_msg)
        return
      }
      context.post('member/imp_verify', {imp_uid: rsp.imp_uid, type: type, sns_id: info?.sns_id ?? '', email: email, pwd: pwd, nick: nickname, name: name, tel: phone, birth: birth, gender: info?.gender},
        () => {
          //회원가입처리됨
          setStep(2)
        },
        true,
        err => {
          context.showAlert(err.msg)
        }
      )
    })
  }

  return (
    <React.Fragment>
      <div className='sign-bg'>
        <div className='signup-container'>
          <div className='fs-28 sm-fs-20 f-b color-0f4c81'>{strings.user_info}</div>
          <div className='d-center mt-30 sm-mt-20'>
            <div className='d-block'>
              <img className='step_icon' src={step === 1 ? '/assets/image/step1_on.png' : '/assets/image/step1.png'} alt='' />
              <div className={'fs-16 sm-fs-14 f-sb ' + (step === 1 ? 'color-0f4c81' : 'color-9e9e9e')}>{strings.info_register}</div>
            </div>
            <div className='divider_dash' />
            <div className='d-block'>
              <img className='step_icon' src={step === 2 ? '/assets/image/step2_on.png' : '/assets/image/step2.png'} alt='' />
              <div className={'fs-16 sm-fs-14 f-sb ' + (step === 2 ? 'color-0f4c81' : 'color-9e9e9e')}>{strings.signup_complete}</div>
            </div>
          </div>
          {step === 1 &&
            <div className='signup-div mt-30 text-left'>
              <div className='txt fs-16 sm-fs-14'>{strings.signup_desc}</div>
              <label className='control-label mt-40 sm-mt-20'>{strings.email}<span className='text-danger'>*</span></label>
              <div className='auth_div'>
                <AppInput className={''} errorMsg={emailError} disable={authStatus > 0 && (type === 1 || checkEmail(info?.email ?? ''))} placeholder={strings.email_hint} inputType={'email'} value={email} onChange={(v) => { setEmailChecked(false); setEmail(v) }} />
                <button type='button' className='btn btn-default' disabled={authStatus > 0} hidden={true} onClick={() => {sendAuth()}}>{authStatus === -1 ? strings.auth : strings.re_auth}</button>
                <button type='button' className='btn btn-default' hidden={type > 1} onClick={() => checkID()}>{strings.double_check}</button>
              </div>
              {authStatus > 0 && authStatus < 2 &&
              <React.Fragment>
                <div className='d-center'>
                  <div className={'invalid-feedback error flex-full'}>{strings.auth_sent}</div>
                  <div className={'fs-14 sm-fs-12 f-m color-9e9e9e mr-4 mt-6'}>{getTimeFromSecond(authTime)}</div>
                </div>
                <AppInput className={'mt-12'} errorMsg={authError} disable={authStatus === 2} placeholder={strings.auth_hint} inputType={'text'} maxLength={6} value={auth} onChange={(v) => {setAuth(v)}}/>
                <button type='button' className='btn btn-default mt-6' disabled={authStatus === 2} onClick={() => {requestAuth()}}>{strings.confirm}</button>
              </React.Fragment>
              }
              {info == null &&
                <React.Fragment>
                  <label className='control-label mt-20 sm-mt-18'>{strings.pwd}<span className='text-danger'>*</span></label>
                  <AppInput className={''} errorMsg={pwdError} placeholder={strings.pwd_hint} inputType={'password'} value={pwd} onChange={(v) => { setPwd(v) }} />
                  <label className='control-label mt-20 sm-mt-18'>{strings.pwd_d}<span className='text-danger'>*</span></label>
                  <AppInput className={''} errorMsg={pwdDError} placeholder={strings.pwd_hint} inputType={'password'} value={pwdD} onChange={(v) => { setPwdD(v) }} />
                </React.Fragment>
              }
              <label className='control-label mt-20 sm-mt-18'>{strings.nickname}<span className='text-danger'>*</span></label>
              <div className='auth_div'>
                <AppInput className={''} errorMsg={nicknameError} placeholder={strings.nickname_hint} inputType={'text'} value={nickname} onChange={(v) => { setNickChecked(false); setNickname(v) }} />
                <button type='button' className='btn btn-default' onClick={() => checkNickname()}>{strings.double_check}</button>
              </div>
              <label className='control-label mt-20 sm-mt-18'>{strings.phone}<span className='text-danger'>*</span></label>
              <AppInput className={''} errorMsg={phoneError} disable={info != null && info.tel && info.tel.replace(/-/g, '').replace(/ /g, '').length === 11} placeholder={strings.phone_hint} inputType={'phone'} value={phone} onChange={(v) => { setPhone(v) }} />
              <label className='control-label mt-20 sm-mt-18'>{strings.name}<span className='text-danger'>*</span></label>
              <AppInput className={''} errorMsg={nameError} disable={info != null} placeholder={strings.name_hint} inputType={'text'} value={name} onChange={(v) => { setName(v) }} />
              <label className='control-label mt-20 sm-mt-18'>{strings.birthday}<span className='text-danger'>*</span></label>
              <AppInput className={birthValid ? '' : 'hide'} errorMsg={''} disable={true} placeholder={strings.birthday_hint} inputType={'text'} value={initialBirth} onChange={(v) => { }} />
              {!birthValid && <DateTime dateFormat={FORMAT.DATE} timeFormat={false} initialValue={initialBirth} closeOnSelect={true} inputProps={{ placeholder: strings.birthday_hint }} onChange={(v) => setBirth(v)} />}
              <div className={'invalid-feedback ' + (birthError !== '' ? 'error' : '')}>{birthError}</div>
              {/* <div className='mt-20 sm-mt-18 d-flex align-items-center email_alarm'>
                <div className='flex-grow-1'>
                  <div className='fs-16 sm-fs-14 f-sb'>{strings.email_alarm}</div>
                  <div className='desc fs-15 sm-fs-12 f-m color-9e9e9e mt-3'>{strings.email_alarm_desc}</div>
                </div>
                <img className='is_on cursor-point' src={emailAlarm ? '/assets/image/is_on.png' : '/assets/image/is_off.png'} alt='' onClick={() => setEmailAlarm(!emailAlarm)} />
              </div> */}
              <div className='divider mt-20' />
              <div className='d-flex align-items-center cursor-point mt-40 sm-mt-20' onClick={ toogleAllAgreement }>
                <img className='checkbox' src={agreement.length === agreementList.length ? '/assets/image/chk_on.png' : '/assets/image/chk.png'} alt='' />
                <div className='fs-15 sm-fs-14 f-sb ml-10'>{strings.agree_all}</div>
              </div>
              <div className='d-flex align-items-center  mt-14'>
                <img className='checkbox cursor-point' src={agreement.includes("usage") ? '/assets/image/chk_on.png' : '/assets/image/chk.png'} alt='' onClick={() => toogleSingleAgreement("usage")} />
                <div className='fs-15 sm-fs-14 f-sb ml-10 cursor-point' onClick={() => toogleSingleAgreement("usage")} >{strings.agree_usage}</div>
                <a className='f-sb login_signup fs-15 f-sb color-9e9e9e ml-20' href={'/cs/term/0'}>{strings.view_detail}</a>
              </div>
              <div className='d-flex align-items-center mt-14 mb-40'>
                <img className='checkbox cursor-point' src={agreement.includes("privacy") ? '/assets/image/chk_on.png' : '/assets/image/chk.png'} alt='' onClick={() => toogleSingleAgreement("privacy")} />
                <div className='fs-15 sm-fs-14 f-sb ml-10 cursor-point' onClick={() => toogleSingleAgreement("privacy")}>{strings.agree_privacy}</div>
                <a className='f-sb login_signup fs-15 f-sb color-9e9e9e ml-20' href={'/cs/term/1'}>{strings.view_detail}</a>
              </div>
              <ConfirmButton enabled={enabled} className={'btn btn-login mt-40 fs-15 f-sb '} onClick={handleSubmit} text={strings.next} />
            </div>
          }
          {step === 2 &&
            <div className='mt-30'>
              <div className='signup-div signup-div1'>
                <div className='fs-20 sm-fs-16 f-b'>{strings.signup_completed}</div>
                <div className='fs-16 sm-fs-14 f-m fls-1 color-9e9e9e mt-20'>{strings.signup_completed_desc1}</div>
                <div className='fs-16 sm-fs-14 f-m fls-1 color-9e9e9e'>{strings.signup_completed_desc2}</div>
                <div className='signup_done mt-60 sm-mt-30 d-center'>
                  <div className='fs-16 sm-fs-14 f-m fls-1'>{strings.signup_completed_desc3}</div>
                </div>
              </div>
              <div className='d-flex justify-content-center mt-30'>
                <button type='button' className='btn btn-login1 btn-white fs-15 f-sb mr-10' onClick={() => { props.history.replace('/dashboard') }}>{strings.to_main}</button>
                <ConfirmButton enabled={true} className={'btn btn-login1 btn-login fs-15 f-sb'} onClick={() => { props.history.replace('/login') }} text={strings.login} />
              </div>
            </div>
          }
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(Signup)
